exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* @import \"react-toolbox/lib/variables.css\"; */\r\n\r\n/* @import \"react-toolbox/lib/colors.css\"; */\r\n\r\n/* RT Appbar */\r\n\r\n/* RT Drawer */\r\n\r\n/* RT List */\r\n\r\n/* Footer */\r\n\r\n.styles--footer--30bVOUO0 {\r\n  background-color: rgb(25, 118, 210);\r\n  color: rgb(255, 255, 255);\r\n  padding-left: 24px;\r\n}\r\n\r\n.styles--link--37JSuaOe {\r\n  color: rgb(255, 255, 255);\r\n}\r\n", ""]);

// exports
exports.locals = {
	"footer": "styles--footer--30bVOUO0",
	"link": "styles--link--37JSuaOe"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./node_modules/postcss-loader/lib!./src/components/AppFooter/styles.css
// module id = 1070
// module chunks = 1